import React, { useEffect, useState } from "react";
import { Container } from "./styles";
import api from "../../services/api";
import { addDays } from "date-fns";
import {
  DatePicker,
  Card,
  Row,
  Col,
  Statistic,
  Tag,
  Progress,
  Radio,
  Spin,
} from "antd";
import {
  UserOutlined,
  ArrowUpOutlined,
  CalendarOutlined,
  ClockCircleOutlined,
} from "@ant-design/icons";
import dayjs from "dayjs";
import weekday from "dayjs/plugin/weekday";
import localeData from "dayjs/plugin/localeData";
import { getDate, returnCatch } from "../../services/functions";
import { ViewInput } from "../../GlobalStyles";

const { RangePicker } = DatePicker;

dayjs.extend(weekday);
dayjs.extend(localeData);

export default function HomeAdmin() {
  const [resume, setResume] = useState({});
  const [loading, setLoading] = useState(true);
  const [dateStart, setDateStart] = useState(addDays(new Date(), -30));
  const [dateEnd, setDateEnd] = useState(new Date());

  useEffect(() => {
    loadingScreen();
  }, [dateStart, dateEnd]);

  async function loadingScreen() {
    setLoading(true);
    await api
      .get(`/admin/dash?date_start=${dateStart}&date_end=${dateEnd}`)
      .then((response) => {
        setResume(response.data);
      })
      .catch(({ response }) => {
        returnCatch(response);
      });
    setLoading(false);
  }

  const contentStats = [
    {
      lang: "Português",
      flag: "🇧🇷",
      count: "contentsPTBR",
    },
    { lang: "English", flag: "🇺🇸", count: "contentsENUS" },
    { lang: "Español", flag: "🇪🇸", count: "contentsESES" },
  ];

  const planStats = [
    {
      name: "Gratuito",
      count: "usersTotalFree",
      totalUser: true,
      color: "#d9d9d9",
    },
    {
      name: "Premium",
      count: "usersTotalPremium",
      totalUser: true,
      color: "gold",
    },
    { name: "Mensal", count: "usersTotalPremiumMensal", color: "#722ed1" },
    { name: "Anual", count: "usersTotalPremiumAnual", color: "#008037" },
  ];

  const handleQuickFilter = (e) => {
    const val = e.target.value;
    const end = new Date();
    let start = new Date();

    if (val === "24h") {
      start = addDays(end, -1);
    } else if (val === "7d") {
      start = addDays(end, -7);
    }

    setDateStart(start);
    setDateEnd(end);
  };

  return (
    <Container>
      <h1>Dashboard</h1>
      <div
        style={{
          display: "flex",
          flexWrap: "wrap",
          gap: 20,
          marginBottom: 20,
          alignItems: "flex-end",
        }}
      >
        <ViewInput style={{ width: "100%", maxWidth: 300, marginBottom: 0 }}>
          <p>Alterar Período</p>
          <RangePicker
            style={{ width: "100%" }}
            placeholder={["Data inicial", "Data final"]}
            value={[
              dateStart ? dayjs(dateStart) : "",
              dateEnd ? dayjs(dateEnd) : "",
            ]}
            format={"DD/MM/YYYY"}
            onChange={(value, dateString) => {
              setDateStart(getDate(dateString[0]));
              setDateEnd(getDate(dateString[1]));
            }}
            allowClear={false}
          />
        </ViewInput>

        <Radio.Group onChange={handleQuickFilter} buttonStyle="solid">
          <Radio.Button value="24h">Últimas 24h</Radio.Button>
          <Radio.Button value="7d">Última Semana</Radio.Button>
        </Radio.Group>
      </div>

      {loading ? (
        <Spin size="large" style={{ marginTop: 110 }} />
      ) : (
        <>
          <Row gutter={[16, 16]} style={{ marginBottom: 30 }}>
            <Col xs={24} sm={12} md={6}>
              <Card
                bordered={false}
                style={{ boxShadow: "0 2px 8px rgba(0,0,0,0.05)" }}
              >
                <Statistic
                  title="Total de Usuárias"
                  value={resume.usersTotal}
                  prefix={<UserOutlined />}
                  valueStyle={{ color: "#008037" }}
                />
              </Card>
            </Col>
            <Col xs={24} sm={12} md={6}>
              <Card
                bordered={false}
                style={{ boxShadow: "0 2px 8px rgba(0,0,0,0.05)" }}
              >
                <Statistic
                  title="Novas (24h)"
                  value={resume.usersTotalLastDay}
                  prefix={<ClockCircleOutlined />}
                  valueStyle={{ color: "#faad14" }}
                />
              </Card>
            </Col>
            <Col xs={24} sm={12} md={6}>
              <Card
                bordered={false}
                style={{ boxShadow: "0 2px 8px rgba(0,0,0,0.05)" }}
              >
                <Statistic
                  title="Novas (7 Dias)"
                  value={resume.usersTotalLastWeek}
                  prefix={<CalendarOutlined />}
                  valueStyle={{ color: "#108ee9" }}
                />
              </Card>
            </Col>
            <Col xs={24} sm={12} md={6}>
              <Card
                bordered={false}
                style={{
                  boxShadow: "0 2px 8px rgba(0,0,0,0.05)",
                  border: "1px solid #008037",
                }}
              >
                <Statistic
                  title="Cadastros no Período"
                  value={resume.usersTotalPeriod}
                  prefix={<ArrowUpOutlined />}
                  valueStyle={{ color: "#008037" }}
                  suffix={
                    <span style={{ fontSize: 12, color: "#999" }}>
                      selecionado
                    </span>
                  }
                />
              </Card>
            </Col>
          </Row>

          <h1 style={{ marginTop: 20 }}>Planos</h1>
          <Card
            bordered={false}
            style={{ marginBottom: 30, boxShadow: "0 2px 8px rgba(0,0,0,0.1)" }}
          >
            <Row gutter={[32, 16]}>
              {planStats.map((plan) => (
                <Col xs={24} sm={12} md={6} key={plan.name}>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      marginBottom: 5,
                    }}
                  >
                    <span style={{ fontWeight: "bold" }}>{plan.name}</span>
                    <span>{resume[plan.count]} usuárias</span>
                  </div>
                  <Progress
                    percent={(
                      (resume[plan.count] /
                        (plan.totalUser
                          ? resume.usersTotal
                          : resume.usersTotalPremium)) *
                      100
                    ).toFixed(1)}
                    showInfo={false}
                    strokeColor={plan.color}
                    size="small"
                  />
                </Col>
              ))}
            </Row>
          </Card>

          <h1 style={{ marginTop: 30 }}>Conteúdos</h1>
          <Row gutter={[16, 16]} style={{ marginBottom: 30 }}>
            {contentStats.map((item) => (
              <Col xs={24} sm={12} key={item.lang}>
                <Card
                  title={
                    <span style={{ fontSize: 18 }}>
                      {item.flag} {item.lang}
                    </span>
                  }
                  bordered={false}
                  style={{ boxShadow: "0 2px 8px rgba(0,0,0,0.1)" }}
                >
                  <Row gutter={[20, 20]}>
                    <Col xs={12} md={6}>
                      <Statistic
                        title="Receitas"
                        value={resume[item.count].nutritionsTotal}
                        valueStyle={{
                          color: "#008037",
                          textAlign: "center",
                        }}
                        style={{
                          textAlign: "center",
                        }}
                      />
                    </Col>
                    <Col xs={12} md={6}>
                      <Statistic
                        title="Exercícios"
                        value={resume[item.count].exercisesTotal}
                        valueStyle={{
                          color: "#008037",
                          textAlign: "center",
                        }}
                        style={{
                          textAlign: "center",
                        }}
                      />
                    </Col>
                    <Col xs={12} md={6}>
                      <Statistic
                        title="Artigos"
                        value={resume[item.count].articlesTotal}
                        valueStyle={{
                          color: "#008037",
                          textAlign: "center",
                        }}
                        style={{
                          textAlign: "center",
                        }}
                      />
                    </Col>
                    <Col xs={12} md={6}>
                      <Statistic
                        title="Dicas"
                        value={resume[item.count].insightsTotal}
                        valueStyle={{
                          color: "#008037",
                          textAlign: "center",
                        }}
                        style={{
                          textAlign: "center",
                        }}
                      />
                    </Col>
                  </Row>
                  <div style={{ marginTop: 15, textAlign: "center" }}>
                    <Tag
                      color="#008037"
                      style={{
                        width: "100%",
                        textAlign: "center",
                        fontSize: 14,
                        padding: 5,
                      }}
                    >
                      Total:{" "}
                      {resume[item.count].insightsTotal +
                        resume[item.count].articlesTotal +
                        resume[item.count].exercisesTotal +
                        resume[item.count].nutritionsTotal}{" "}
                      itens
                    </Tag>
                  </div>
                </Card>
              </Col>
            ))}
          </Row>
        </>
      )}
    </Container>
  );
}
